import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error__modal" }
const _hoisted_2 = { class: "error__title" }
const _hoisted_3 = { class: "error__text" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppError',
  props: {
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  buttonLabel: {
    type: String,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

//import { config } from "../constants";

const emit = __emit;

function closeErrorModal(e: any) {
  if (e.target.classList.contains("error__wrapper")) {
    emit("close");
  }
}

// used to be the created function
document.addEventListener("keydown", (e) => {
  if (e.code === "Escape") {
    emit("close");
  }
});
////

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "error__wrapper",
    onClick: closeErrorModal
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "error__image" }, null, -1)),
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.text), 1),
      _createElementVNode("button", {
        class: "button button--black",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, _toDisplayString(__props.buttonLabel), 1)
    ])
  ]))
}
}

})